import { AxiosResponse } from "axios";
import { UserResponse } from "../interfaces/user";
import axios, { getHeaders } from "./axios";


export interface GetUserRequestBody {
  access_token: string;
}

export interface UpdateFcmtokenBody {
  status: string;
}

export interface ChangeRolesUserBody {
  name?: string;
  email?: string;
  role?: string;
  isAvailable?: boolean;
  birthday?: string;
  /** Per-user override; null clears (use global). dev-only on the server. */
  dailyOrderLimit?: number | null;
}

export interface CreateFcmtokenBody {
  notification_token: string;
}

export const getUserMe = async (
  body: GetUserRequestBody
): Promise<UserResponse> => {
  const headers = getHeaders();
  // If access token is passed in body, use it in header
  if (body.access_token) {
    headers.headers.Authorization = "Bearer " + body.access_token;
  }
  try {
    const response = await axios.get("/user/me", headers);
    return response.data;
  } catch (error: any) {
    console.log("Access denied 401 (getUserMe)");
    throw error;
  }
};



export type AllUser = UserResponse[];

export const getAllUser = async (): Promise<AllUser> => {
  const headers = getHeaders();
  const response: AxiosResponse<AllUser> = await axios.get("/user", headers);
  return response.data;
};

export const getUserByID = async (id: number): Promise<UserResponse> => {
  const headers = getHeaders();
  const response = await axios.get(`/user/${id}`, headers);
  return response.data;
};

//do not done bug in backend
export const deleteUserByID = async (id: number): Promise<UserResponse> => {
  const headers = getHeaders();
  const response = await axios.delete(`/user/${id}`, headers);
  return response.data;
};

export const patchUserByID = async (
  id: number,
  body: ChangeRolesUserBody
): Promise<UserResponse> => {
  const headers = getHeaders();
  const response = await axios.patch<UserResponse>(
    `/user/${id}`,
    body,
    headers
  );
  return response.data;
};

export const adminResetPassword = async (id: number, password: string): Promise<{ message: string }> => {
  const headers = getHeaders();
  const response = await axios.post<{ message: string }>(
    `/user/${id}/change-password/by-admin`,
    { password },
    headers,
  );
  return response.data;
};

export const pathName = async (body: string) => {
  const headers = getHeaders();
  const payload = {
    name: body,
  };
  const response = await axios.patch(`/user`, payload, headers);
  return response.data;
};

export const pushFcmToken = async (
  id: number,
  body: CreateFcmtokenBody
): Promise<UserResponse> => {
  const headers = getHeaders();
  const response = await axios.put<UserResponse>(
    `/user/${id}/push/enable`,
    body,
    headers
  );
  return response.data;
};

export const disableFcmToken = async (
  id: number,
  body: UpdateFcmtokenBody
): Promise<UserResponse> => {
  const headers = getHeaders();
  const response = await axios.put<UserResponse>(
    `/user/${id}/push/disable`,
    body,
    headers
  );
  return response.data;
};

export interface UserRankingResponse {
  rank: number;
  userId: number;
  name: string;
  email: string;
  totalCups: number;
  profileImage?: string; // Keeping this optional just in case, though not in example
}

export interface RankingResponse {
  rankings: UserRankingResponse[];
  myRank?: UserRankingResponse;
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const getUserRanking = async (page: number = 1, limit: number = 20): Promise<RankingResponse> => {
  const headers = getHeaders();
  const url = `/user/ranking?page=${page}&limit=${limit}`;
  const response = await axios.get<RankingResponse>(url, headers);
  return response.data;
};

export interface ChangePasswordBody {
  oldPassword: string;
  password: string;
}

export interface ChangePasswordResponse {
  message: string;
  /** New token pair — the server revokes all refresh tokens on change. */
  accessToken?: string;
  refreshToken?: string;
}

export const changePasswordAPI = async (
  body: ChangePasswordBody
): Promise<ChangePasswordResponse> => {
  const headers = getHeaders();
  const response = await axios.post<ChangePasswordResponse>(
    "/user/change-password",
    body,
    headers
  );
  return response.data;
};

